export const SOCIAL_LINKS = {
    facebook: "facebook.com/Amit.Paco",
    instagram: "instagram.com/_studio.paco",
    linkedin: "linkedin.com/company/studiopaco",
    email: "amit@studiopaco.com",
    phone: "+972506757581",
    website: "https://studiopaco.com",
};